export default {
    monitor: {name: "Monitor"},
    keyboard: {name: "Billentyűzet"},
    mouse: {name: "Egér"},
    webcam: {name: "Webkamera"},
    headset: {name: "Fejhallgató"},
    dockingStation: {name: "Dokkoló"},
}